"use client";

import {
  FloatingContext,
  IFloatingOptions,
  useFloatingContext,
} from "@faire/slate/private/floating/FloatingContext";
import { FloatingAlignment } from "@faire/slate/private/floating/types";
import { PopupRoot } from "@faire/slate/private/popup/PopupRoot";
import { useClick } from "@floating-ui/react";
import React from "react";

type IProps = {
  alignment?: FloatingAlignment;
  children: React.ReactNode;
} & Pick<IFloatingOptions, "open" | "onOpenChange">;

export const FilterPopupRoot: React.FC<IProps> = ({
  alignment = "start",
  children,
  open,
  onOpenChange,
}) => (
  <FloatingContext open={open} onOpenChange={onOpenChange}>
    <Root alignment={alignment} controlled={open !== undefined}>
      {children}
    </Root>
  </FloatingContext>
);

const Root: React.FC<{
  alignment: FloatingAlignment;
  children: React.ReactNode;
  controlled: boolean;
}> = ({ alignment, children, controlled }) => {
  const { floatingRootContext } = useFloatingContext();
  const click = useClick(floatingRootContext, { enabled: !controlled });

  return (
    <PopupRoot
      alignment={alignment}
      interactions={[click]}
      position="bottom"
      role="dialog"
    >
      {children}
    </PopupRoot>
  );
};
